import { useEffect, useState } from 'react';
// import { useLocation } from "react-router-dom";

// @Utility
import filterImages from "@utility/app/filterImages";

// Redux & Action
import { useSelector } from 'react-redux';

// Component
import Slider from 'react-slick';
import ProgressiveImage from "views/components/ProgressiveImage";
import NavbarPromotion from "views/components/NavbarPromotion";

// Style & CSS
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function BrannerSlide({ isLargeScreen, dataSetting, pathname, isUserLoggedIn }) {
    const [dataList, setDataList] = useState(null);
    const homeData = useSelector(state => state.reduxHome.result);

    const settings = {
        infinite: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 600,
        autoplaySpeed: 3000,
        arrows: isLargeScreen ? true : false,
        accessibility: true
    };

    useEffect(() => {
        if (dataSetting.agent_image !== null) {
            const dataImages = filterImages(dataSetting.agent_image, "slide")
            setDataList(dataImages);
        }
    }, [dataSetting.agent_image]);

    return (
        pathname === "/" && (
            dataList !== null && (
                <>
                    {
                        dataList.length > 0 && (
                            <Slider {...settings}>
                                {
                                    dataList.map((item) => {
                                        return (
                                            <div key={item.id}>
                                                <ProgressiveImage className="cardCoverCamp cursorPointer" placeholder="/images/bluring/1000x250.jpg" src={isLargeScreen ? item.image_picture : item.picture_mobile}></ProgressiveImage>
                                            </div>
                                        )
                                    })
                                }
                            </Slider>
                        )
                    }

                    {
                        isUserLoggedIn() && (
                            homeData !== null && (
                                homeData.promotion_status === 1 && (
                                    <NavbarPromotion></NavbarPromotion>
                                )
                            )
                        )
                    }
                </>
            )
        )
    );
}